import { SpecialEventType } from '../../ampli';
import type { IdentifyEvent, Middleware } from '../../ampli';
import Analytics from '../../modules/analytics/Analytics';

export type SegmentExtra = {
    segment?: {
        anonymousId?: string;
        callback?: (...args: Array<unknown>) => void;
    };
};

/**
 * getSegmentMiddleware
 *
 * Initializes Segment tracker and returns Segment Middleware
 */
const segmentMiddleware: Middleware = (payload, next) => {
    const { event, extra } = payload;
    const segmentExtra = extra as SegmentExtra;
    const anonymousId = segmentExtra?.segment?.anonymousId;
    const segmentCallback = segmentExtra?.segment?.callback;

    switch (event.event_type) {
        case SpecialEventType.Identify: {
            const { user_id } = event as IdentifyEvent;

            // @ts-expect-error TS(2339): Property 'analytics' does not exist on type 'Windo... Remove this comment to see the full error message
            window.analytics.identify(user_id, event.event_properties, { anonymousId }, segmentCallback);
            break;
        }

        case SpecialEventType.Group:
            // @ts-expect-error TS(2339): Property 'analytics' does not exist on type 'Windo... Remove this comment to see the full error message
            window.analytics.group(event.event_properties);
            break;

        default:
            Analytics.track(event.event_type, event.event_properties);
            break;
    }

    next(payload);
};

export default segmentMiddleware;
